const LOADING_CHUNK_ERROR_REGEX = /.*Loading.+chunk.+failed.*/;

export default function isChunkLoadError(errorMessage) {
  if (!errorMessage) {
    return false;
  }

  return LOADING_CHUNK_ERROR_REGEX.test(errorMessage);
}
